<template>
  <div>
    <v-layout class="pb-2">
      <span class="subheading"
        ><b>{{ $t("screener.seats_planner.title") }}</b></span
      >
    </v-layout>
    <v-layout row wrap>
      <v-flex xs12>
        <v-card class="border-grey-all" flat>
          <v-card-text>
            <div class="py-2">
              <div>
                <div class="subheading pb-2">
                  <b>{{$t('screener.pricing_type.title')}}</b>
                </div>
                <p class="greyDarken3--text">
                  <template v-if="pricing_type==DEFINES.PREMIUM_SCREENING_PRICING_TYPE.REDUCED && company" >
                    {{
                      $t('screener.pricing_type.reduced.subtitle',{
                        pricing_type:DEFINES.PREMIUM_SCREENING_PRICING_TYPE_STR[pricing_type],
                        commission_percentage:company.reduced_price_commission_percentage
                      })
                    }}
                  </template>
                  <template v-else>
                    {{
                      $t('screener.pricing_type.normal.subtitle',{
                        pricing_type:DEFINES.PREMIUM_SCREENING_PRICING_TYPE_STR[pricing_type]
                      })
                    }}
                  </template>
                </p>
              </div>
              <div>
                <div class="subheading pb-2">
                  <b>{{ $t("participants.title") }}</b>
                </div>
                <p class="greyDarken3--text mb-5">
                  {{ $t("screener.premium_type.description") }}
                </p>
              </div>
              <v-layout
                style="height: 7vh"
                class="justify-center pb-2 px-5 mb-4"
              >
                <vue-slider
                  v-model="participant_slot"
                  :data="DEFINES.PREMIUM_SCREENING_PARTICIPANT_SLOTS[pricing_type]"
                  :data-value="'id'"
                  :data-label="'label'"
                  :adsorb="true"
                  :dot-options="dotOptions"
                  :order="false"
                  class="px-0"
                  height="15px"
                  width="100%"
                  :tooltip-formatter="tooltipFormatter"
                  :tooltipStyle="tooltipStyle"
                >
                  <template v-slot:label="{ label }">
                    <div class="vue-slider-mark-label pr-2">
                      {{ label }}
                    </div>
                  </template>
                </vue-slider>
              </v-layout>
            </div>
            <v-layout row wrap class="pb-3">
              <v-flex xs12 md6>
                <div>
                  <div class="display-2">
                    {{ screener ? screener.total_registrants : 0 }}&nbsp;/&nbsp;{{
                      total_participants
                    }}
                  </div>
                  <div class="subheading greyDarken3--text">
                    {{ $t("screener.premium_type.participation_used") }}
                  </div>
                </div>
              </v-flex>
              <v-flex xs12 md6 class="text-md-right">
                <div>
                  <div class="display-2">
                    {{ DEFINES.PREMIUM_SCREENING_BASE_CURRENCY_SYMBOL
                    }}{{ screener ? _calculatePaidAmount(screener) : 0 }}&nbsp;/&nbsp;{{
                      DEFINES.PREMIUM_SCREENING_BASE_CURRENCY_SYMBOL
                    }}{{ total_amount }}
                  </div>
                  <div class="subheading greyDarken3--text">
                    {{ $t("screener.budget_spent.title") }}
                  </div>
                </div>
              </v-flex>
            </v-layout>
            <v-divider class="mb-3"></v-divider>
            <v-layout v-if="screener" row wrap>
              <v-flex xs12 class="text-md-right">
                <v-btn
                  color="grey"
                  class="mt-0 ml-0"
                  large
                  dark
                  flat
                  @click="$emit('onCancel')"
                  >{{ $t("rms.button.cancel") }}</v-btn
                >
                <v-btn
                  large
                  class="mt-0 mr-0"
                  color="secondary"
                  :disabled="screener.limitation == total_participants"
                  @click="handler()"
                  >{{
                    total_participants >= screener.limitation
                      ? $t("screener.upgrade.title")
                      : $t("screener.downgrade.title")
                  }}</v-btn
                >
              </v-flex>
            </v-layout>
            <div class="pb-2">
              <b>{{ $t("screener.how_to_charge.title") }} :</b>
            </div>
            <v-data-table
              dense
              :headers="headers"
              :items="slots"
              hide-actions
              class="border-grey-all mb-3"
            >
              <template v-slot:items="props">
                <tr>
                  <td class="body-1">{{ props.item.consolidated_value }}</td>
                  <td class="body-1">
                    <template v-if="props.item.amount > 0">
                      <span v-if="!props.item.should_charge">+</span
                      >{{ props.item.currency_symbol }}{{ props.item.amount }}
                    </template>
                    <template v-else>{{ props.item.description }}</template>
                  </td>
                  <td>
                    <template
                      v-if="isParticipantSlotPaid(screener, props.item.id)"
                      ><b
                        >{{
                          props.item.currency_symbol +
                          screener.payment_charges[props.item.id].amount
                        }}
                        on
                        {{
                          moment
                            .utc(
                              screener.payment_charges[props.item.id].paid_on
                            )
                            .local()
                            .format("Do MMM YYYY")
                        }}</b
                      >
                      <v-tooltip top color="white">
                        <template v-slot:activator="{ on }">
                          <v-icon v-on="on" class="px-1" color="success" small
                            >$vuetify.icons.rms_rule_is_enabled</v-icon
                          >
                        </template>
                        <span class="grey--text text--darken-3 body-1">
                          {{ $t("screener.premium_type.paid_budget.tooltip") }}
                        </span>
                      </v-tooltip>
                    </template>
                    <template v-else>
                      <span
                        v-if="
                          props.item.amount ==
                          DEFINES.PREMIUM_SCREENING_BASE_CHARGEABLE_AMOUNT
                        "
                        class="font-weight-bold error--text"
                        >{{ props.item.charge_on }}</span
                      >
                      <span v-else>{{ props.item.charge_on }}</span>
                    </template>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import VueSlider from "vue-slider-component";
import "vue-slider-component/theme/default.css";
import DEFINES from "@/defines";
import rules from "@/validation";
import i18n from "@/i18n";
import { mapGetters } from "vuex";
import { _calculatePaidAmount } from "@/mixins/screening";

export default {
  name: "ScreenerSeatsPlanner",
  props: {
    screener: {
      type: Object,
      default: null,
    },
    company:{
      type: Object,
      default: null,
    },
    minSlot: {
      type: String,
      default: DEFINES.PREMIUM_SCREENING_DEFAULT_SLOT,
    },
    selectedSlot: {
      type: String,
      default: DEFINES.PREMIUM_SCREENING_DEFAULT_SLOT,
    },
  },
  data() {
    return {
      // Slider data
      participant_slot: this.selectedSlot,
      dotOptions: {
        min: this.minSlot,
        tooltip: "always",
      },
      tooltipStyle: {
        padding: "6px",
        fontWeight: "bold",
      },
      headers: [
        {
          text: "Maximum Participants Allowed",
          align: "left",
          sortable: false,
          value: "name",
        },
        {
          text: "Additional Charges",
          align: "left",
          sortable: false,
          value: "name",
        },
        {
          text: "When will you be charged",
          align: "left",
          sortable: false,
          value: "name",
        },
      ],
      slots: [],
      total_amount: 0,
      total_participants: 0,
      tooltipFormatter: (value) => i18n.t(`${value + ".tooltip"}`),
    };
  },
  components: {
    VueSlider,
  },
  mixins: [_calculatePaidAmount],
  computed: {
    ...mapGetters("screener", {
      isParticipantSlotPaid: "isParticipantSlotPaid",
    }),
    pricing_type(){
      if(this.screener){
        return this.screener.pricing_type
      }

      return DEFINES.PREMIUM_SCREENING_PRICING_TYPE.NORMAL
    }
  },
  mounted() {
    this.setSlots(this.participant_slot);
  },
  watch: {
    participant_slot(slot_id) {
      this.setSlots(slot_id);
    },
    screener:{
      deep:true,
      handler:function(){
        this.setSlots(this.participant_slot);
      }
    }
  },
  methods: {
    handler() {
      switch (this.screener.screening_type) {
        case DEFINES.SCREENING_PLAN_TYPE.FREE:
          this.$emit("goToStep", 3);
          break;
        case DEFINES.SCREENING_PLAN_TYPE.PREMIUM:
          this.$emit("onUpgrade");
          break;
        default:
          break;
      }
    },
    setSlots(slot_id = "participant_slot_4_50") {
      if (!slot_id) {
        return;
      }

      var vue = this;
      this.slots = [];
      this.total_amount = 0;
      this.total_participants = 0;
      DEFINES.PREMIUM_SCREENING_PARTICIPANT_SLOTS[this.pricing_type].every(function (slot, index) {
        if (slot.active) {
          vue.total_amount += slot.amount;
          vue.total_participants += slot.value;
        }
        vue.slots.push(slot);
        return slot.id !== slot_id; // Returning true terminates the loop
      });

      var active_slot_ids = this.slots
        .map((slot) => (slot.active ? slot.id : undefined))
        .filter((slot_id) => slot_id !== undefined);

      this.$emit("update:slots", active_slot_ids);
      this.$emit("update:total_participants", this.total_participants);
    },
    reset() {
      this.setSlots();
      this.participant_slot = "participant_slot_4_50";
    },
  },
};
</script>

<style></style>
